import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ValetReferralForm from './ValetReferralForm';
import { createEmployeeClientReferral } from 'services/redux/valetReferral/action';

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createEmployeeClientReferral,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(ValetReferralForm);
